import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { PDFDocument } from "pdf-lib";
import VisibilitySensor from "react-visibility-sensor";
import PuffLoader from "react-spinners/PuffLoader";
import { getDownloadCenter } from "../assets/js/content";
import { getRightContent, getVisibleSensorAnimation } from "../assets/js/utils";
// import downloadImage from "../assets/images/download-1.png";
import downloadImage from "../assets/images/download-icon.svg";
import closeImage from "../assets/images/close_section.svg";
import CheckBoxList from "./CheckBoxList";
import { getLanguageFolder, getPdfName } from "../assets/js/pdfHandler";
import constants from "../assets/js/constants";

const downloadCenterContent = getDownloadCenter();
const urlEndpoint = `./download-center`;

function DownloadCenter(props) {
  const [checkedChapters, setCheckedChapters] = useState(
    new Array(downloadCenterContent.chaptersDescription.length)
  );
  const [isLoading, setIsLoading] = useState(false);
  const [fileDownloadUrl, setFileDownloadUrl] = useState("");

  const generalSettings = useSelector((state) => state.ui.generalSettings);

  useEffect(() => {
    resetCheckedChapters();
  }, []);
  const resetCheckedChapters = () => {
    const copyList = new Array(
      downloadCenterContent.chaptersDescription.length
    );
    for (let i = 0; i < downloadCenterContent.chaptersDescription.length; i++) {
      copyList[i] = new Array(
        downloadCenterContent.chaptersDescription[i].sections.length
      ).fill(false);
    }

    setCheckedChapters(copyList);
  };

  const handleDownloadSpecificChapters = async () => {
    const promisesPDFUrls = [];
    setIsLoading(true);

    for (let i = 0; i < checkedChapters.length; i++) {
      for (let j = 1; j < checkedChapters[i].length; j++) {
        //start from 1 to avoid the cover.pdf
        if (checkedChapters[i][j]) {
          promisesPDFUrls.push(
            `${urlEndpoint}/${getLanguageFolder(generalSettings.rtlLanguage)}/${
              i + 1
            }/${getPdfName(i, j)}`
          );
        }
      }
    }

    const fetchPromises = promisesPDFUrls.map((url) =>
      fetch(url, {
        headers: {
          "Content-Type": "application/pdf",
          "Content-disposition": "attachment",
        },
      }).then((res) => res.arrayBuffer())
    );
    const chaptersPDF = await Promise.all(fetchPromises);

    const loadedDocuments = await Promise.all(
      chaptersPDF.map((pdfToload) => PDFDocument.load(pdfToload))
    );

    const pdfDoc = await PDFDocument.create();

    for (const loadDocument of loadedDocuments) {
      const pages = await pdfDoc.copyPages(
        loadDocument,
        loadDocument.getPageIndices()
      );
      for (const page of pages) {
        pdfDoc.addPage(page);
      }
    }

    const finalPdf = await pdfDoc.save();
    const blob = new Blob([finalPdf], { type: "application/pdf" });
    const url = URL.createObjectURL(blob);
    setIsLoading(false);

    const link = document.createElement("a");
    link.href = url;
    link.download = generalSettings.rtlLanguage
      ? "Bank_AL_Bilad_Partial_Report_AR.pdf"
      : "Bank_AL_Bilad_Partial_Report_EN.pdf";
    document.body.appendChild(link);
    link.click();
    URL.revokeObjectURL(url);
    document.body.removeChild(link);

    resetCheckedChapters();
  };

  const handleDownloadAllChapters = async () => {
    setIsLoading(true);
    const currentLanguage = generalSettings.rtlLanguage ? "arabic" : "english";
    const promiseFetch = await fetch(
      `${urlEndpoint}/${currentLanguage}/bank_al_bilad_${currentLanguage}.pdf`,
      {
        headers: {
          "Content-Type": "application/pdf",
          "Content-disposition": "attachment",
        },
      }
    ).then((response) => response.arrayBuffer());

    const completePdf = await PDFDocument.load(promiseFetch);

    const pdfDoc = await PDFDocument.create();

    const contentCompletePdfPages = await pdfDoc.copyPages(
      completePdf,
      completePdf.getPageIndices()
    );
    for (const page of contentCompletePdfPages) {
      pdfDoc.addPage(page);
    }

    const finalPdf = await pdfDoc.save();

    const blob = new Blob([finalPdf], { type: "application/pdf" });
    const url = URL.createObjectURL(blob);

    setIsLoading(false);

    const link = document.createElement("a");
    link.href = url;
    link.download = generalSettings.rtlLanguage
      ? "Bank_AL_Bilad_Full_Report_AR.pdf"
      : "Bank_AL_Bilad_Full_Report_EN.pdf";
    document.body.appendChild(link);
    link.click();
    URL.revokeObjectURL(url);
    document.body.removeChild(link);

    resetCheckedChapters();
  };

  const handleOnChange = (checkedChapter, index) => {
    const copyCheckedChapters = [...checkedChapters];
    if (index === 0) {
      if (checkedChapters[checkedChapter][0]) {
        copyCheckedChapters[checkedChapter] = copyCheckedChapters[
          checkedChapter
        ].map(() => false);
        // return setCheckedItems(checkedItems.map(() => false));
      } else {
        copyCheckedChapters[checkedChapter] = copyCheckedChapters[
          checkedChapter
        ].map(() => true);
        // return setCheckedItems(checkedItems.map(() => true));
      }

      return setCheckedChapters(copyCheckedChapters);
    }
    const updatedCheckedItems = copyCheckedChapters[checkedChapter].map(
      (item, indexItem) => (index === indexItem ? !item : item)
    );
    copyCheckedChapters[checkedChapter] = updatedCheckedItems;
    setCheckedChapters(copyCheckedChapters);
  };

  return (
    <div className="download-center general-m">
      {/* <svg
        onClick={handleCloseDownloadCenter}
        className={`icon download-center__close-icon`}
      >
        <use xlinkHref={getSprite() + "#close"}></use>
      </svg> */}
      {/* <img src={closeImage} alt="" className="download-center__close-icon" /> */}
      <VisibilitySensor partialVisibility>
        {({ isVisible }) => (
          <h2
            className="download-center__title header"
            // style={{
            //   animation: isVisible ? `fadeIn 2s 0.25s backwards ` : "",
            //   opacity: !isVisible ? 0 : 1,
            // }}
            style={getVisibleSensorAnimation(
              isVisible,
              "fadeIn 1.2s  backwards"
            )}
          >
            {getRightContent(
              generalSettings.rtlLanguage,
              downloadCenterContent.title
            )}
          </h2>
        )}
      </VisibilitySensor>
      <div className="download-center__controls-container">
        <VisibilitySensor partialVisibility>
          {({ isVisible }) => (
            <p
              className="download-center__description"
              style={getVisibleSensorAnimation(
                isVisible,
                "fadeIn 1.2s 0.25s backwards"
              )}
            >
              {getRightContent(
                generalSettings.rtlLanguage,
                downloadCenterContent.description
              )}
            </p>
          )}
        </VisibilitySensor>
        <div className="download-center__buttons">
          <button
            className="download-center__button"
            onClick={async () => await handleDownloadSpecificChapters()}
          >
            <div className="download-center__button-container">
              <img
                src={downloadImage}
                alt=""
                className="download-center__button-icon"
              />
              <span>
                {getRightContent(
                  generalSettings.rtlLanguage,
                  downloadCenterContent.buttonSpecificChaptersLabel
                )}
              </span>
              {/* <svg className={`icon icon--small download-center__button-icon`}>
              <use xlinkHref={getSprite() + "#download"}></use>
            </svg> */}
            </div>
          </button>
          <button
            className="download-center__button"
            onClick={async () => await handleDownloadAllChapters()}
          >
            <div className="download-center__button-container">
              <img
                src={downloadImage}
                alt=""
                className="download-center__button-icon"
              />
              <span>
                {getRightContent(
                  generalSettings.rtlLanguage,
                  downloadCenterContent.buttonAllChaptersLabel
                )}
              </span>
              {/* <svg className={`icon icon--small download-center__button-icon`}>
              <use xlinkHref={getSprite() + "#download"}></use>
            </svg> */}
            </div>
          </button>
        </div>
      </div>
      {isLoading && (
        <div className="download-message__container">
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <PuffLoader
              loading={isLoading}
              size={40}
              // css={override}
              margin={1}
              width={3}
              color={constants.COLORS.PRIMARY}
            />
          </div>

          <h5 className="download-message__title">
            {getRightContent(
              generalSettings.rtlLanguage,
              downloadCenterContent.messageToDownload
            )}
          </h5>
        </div>
      )}
      <div className="download-center__chapters-container">
        {downloadCenterContent.chaptersDescription.map((chapter, index) => (
          <VisibilitySensor partialVisibility>
            {({ isVisible }) => (
              <div
                className="download-center__list"
                // style={{
                //   animation: isVisible
                //     ? `fadeIn 1s ${index * 0.3}s backwards`
                //     : "",
                //   opacity: !isVisible ? 0 : 1,
                // }}
                style={getVisibleSensorAnimation(
                  isVisible,
                  `fadeIn 1s ${index * 0.3}s backwards`
                )}
              >
                <CheckBoxList
                  key={index}
                  list={chapter.sections}
                  chapter={index}
                  handleOnChange={handleOnChange}
                  checkBoxList={checkedChapters[index]}
                />
              </div>
            )}
          </VisibilitySensor>
        ))}
      </div>
    </div>
  );
}

export default DownloadCenter;
